<div class="main-layout" dpadContainer #dpadContainer>
    <side-bar *ngIf="isAuthenticated() && !isPlayerPage"></side-bar>
    <router-outlet></router-outlet>
    <generic-modal *ngIf="showGenericModal"></generic-modal>
    <app-spinner *ngIf="loading"></app-spinner>
</div>



<div id="logger" class="debug-overlay" *ngIf="playstation">
</div>
